var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(1.4676573,0,0,1.4676573,29.851409,18.999436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 82.554626,196.26726 v 5.64 q -0.72,-0.96 -1.824,-1.464 -1.104,-0.504 -2.304,-0.504 -2.16,0 -3.504,1.464 -1.32,1.44 -1.32,3.552 0,2.136 1.344,3.528 1.368,1.392 3.552,1.392 1.152,0 2.232,-0.504 1.08,-0.528 1.824,-1.416 v 5.616 q -0.648,0.216 -1.224,0.36 -0.576,0.168 -1.128,0.288 -0.432,0.096 -0.888,0.144 -0.432,0.048 -0.912,0.048 -1.896,0 -3.648,-0.672 -1.728,-0.696 -3.144,-1.968 -1.488,-1.344 -2.208,-3.072 -0.696,-1.752 -0.696,-3.768 0,-1.848 0.672,-3.576 0.696,-1.728 1.992,-3.048 1.296,-1.32 3.048,-2.088 1.752,-0.792 3.624,-0.84 0.048,0 0.096,0 0.072,0 0.12,0 1.128,0 2.184,0.24 1.08,0.24 2.112,0.672 z m 13.991997,14.52 h -6.48 l -1.248,3.144 h -4.992 l 6.96,-18.096 h 5.136 l 6.815997,18.096 h -5.015997 l -1.176,-3.144 z m -1.272,-3.6 -1.92,-5.76 h -0.048 l -1.944,5.76 h 3.912 z m 13.632007,-11.352 v 14.112 h 5.64 v 3.984 h -10.344 v -18.096 h 4.704 z m 27.21603,1.008 -1.872,3.648 q -0.648,-0.528 -1.464,-0.84 -0.792,-0.336 -1.656,-0.336 -0.12,0 -0.264,0.024 -0.144,0 -0.288,0.048 -0.552,0.12 -1.008,0.48 -0.456,0.36 -0.456,0.96 0,0.576 0.432,0.936 0.432,0.336 0.936,0.552 0.192,0.072 0.36,0.144 0.192,0.048 0.36,0.096 l 1.2,0.336 q 1.896,0.576 3.168,1.68 1.296,1.08 1.296,3.288 0,0.096 0,0.192 0,0.096 0,0.192 -0.048,1.248 -0.456,2.448 -0.408,1.176 -1.416,2.04 -0.912,0.792 -2.064,1.176 -1.152,0.384 -2.352,0.48 -0.192,0 -0.384,0 -0.168,0.024 -0.336,0.024 -1.704,0 -3.336,-0.528 -1.632,-0.552 -3.024,-1.512 l 2.016,-3.816 q 0.888,0.792 1.92,1.344 1.056,0.552 2.256,0.552 0.048,0 0.096,0 0.048,0 0.096,0 0.792,-0.048 1.44,-0.48 0.648,-0.456 0.648,-1.344 0,-0.672 -0.552,-1.08 -0.528,-0.408 -1.2,-0.648 -0.288,-0.096 -0.576,-0.168 -0.288,-0.096 -0.528,-0.168 -0.048,-0.024 -0.12,-0.024 -0.048,-0.024 -0.096,-0.048 -2.136,-0.6 -3.408,-1.536 -1.272,-0.936 -1.272,-3.504 0,-2.76 1.752,-4.416 1.776,-1.656 4.488,-1.656 0.552,0 1.128,0.072 0.576,0.048 1.152,0.192 0.912,0.192 1.776,0.504 0.888,0.312 1.608,0.72 z m 10.17598,2.976 v 14.112 h -4.704 v -14.112 h -3.888 v -3.984 h 12.48 v 3.984 h -3.888 z m 15.24003,10.968 h -6.48 l -1.248,3.144 h -4.992 l 6.96,-18.096 h 5.136 l 6.816,18.096 h -5.016 l -1.176,-3.144 z m -1.272,-3.6 -1.92,-5.76 h -0.048 l -1.944,5.76 h 3.912 z m 14.68802,-7.368 v 14.112 h -4.704 v -14.112 h -3.888 v -3.984 h 12.48 v 3.984 h -3.888 z m 15.88802,0 h -5.592 v 3.024 h 5.304 v 3.984 h -5.304 v 3.12 h 5.592 v 3.984 h -10.296 v -18.096 h 10.296 v 3.984 z m 15.83999,-3.984 v 14.112 h 5.64 v 3.984 h -10.344 v -18.096 h 4.704 z m 18.26402,14.952 h -6.48 l -1.248,3.144 h -4.992 l 6.96,-18.096 h 5.136 l 6.816,18.096 h -5.016 l -1.176,-3.144 z m -1.272,-3.6 -1.92,-5.76 h -0.048 l -1.944,5.76 h 3.912 z",
    id: "text2",
    style: {
      fontSize: 24,
      fontFamily: "Futura-Bold",
      InkscapeFontSpecification: "Futura-Bold",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      fill: "#fdebd3",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      fillOpacity: 1
    },
    "aria-label": "CAL STATE LA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text1",
    style: {
      fontSize: 96,
      fontFamily: "'Market Deco'",
      InkscapeFontSpecification: "'Market Deco'",
      textAlign: "center",
      letterSpacing: 10,
      textAnchor: "middle",
      fill: "#82bd3f",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      fillOpacity: 1
    },
    "aria-label": "TiPSE"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      letterSpacing: 15,
      fill: "#82bd3f",
      fillOpacity: 1
    },
    d: "m 31.109375,115.35938 h 45 v 10.875 h -17.25 v 58.49999 h -10.5 v -58.49999 h -17.25 z m 71.250005,34.62293 10.32245,0.0177 0.17755,34.73437 h -10.5 z",
    id: "path2977"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      letterSpacing: 1,
      fill: "#82bd3f",
      fillOpacity: 1
    },
    d: "m 149.60937,165.46875 v 19.17187 h -10.5 v -68.99999 h 10.5 1.875 q 9.79688,0 16.6875,7.3125 6.89063,7.31249 6.89063,17.62499 0,10.35938 -6.89063,17.67188 -6.89062,7.3125 -16.6875,7.3125 -0.9375,0 -1.875,-0.0937 z m 0,-39.5625 v 29.25 q 0.89063,0.14062 1.875,0.14062 5.76563,0 9.79688,-4.3125 4.07812,-4.3125 4.07812,-10.40625 0,-6.09375 -4.07812,-10.35937 -4.03125,-4.3125 -9.79688,-4.3125 z m 53.03125,58.92187 q -4.5,0 -7.96875,-1.125 -3.42187,-1.125 -7.35937,-4.03125 v -12.89062 q 2.4375,2.57812 3.75,3.51562 1.3125,0.89063 3.1875,1.92188 1.92187,1.03125 4.21875,1.73437 2.29687,0.70313 4.54687,0.70313 4.64063,0 7.59375,-3.1875 3,-3.23438 3,-7.64063 0,-3.60937 -2.53125,-5.85937 -2.53125,-2.25 -8.29687,-5.15625 -3.46875,-1.78125 -5.85938,-3.23438 -2.39062,-1.45312 -4.59375,-3.60937 -2.20312,-2.15625 -3.5625,-5.10938 -1.35937,-3 -1.35937,-7.03125 0.1875,-3.9375 1.92187,-7.31249 1.73438,-3.42188 4.6875,-5.95313 2.95313,-2.57812 6.70313,-3.98437 3.79687,-1.40625 7.96875,-1.40625 3.14062,0.0937 5.71875,0.89062 2.57812,0.75 5.85937,2.76563 v 10.82812 q -1.96875,-1.3125 -2.71875,-1.59375 -0.70312,-0.32812 -2.0625,-1.03125 -1.3125,-0.75 -3.09375,-1.26562 -1.73437,-0.51563 -3.70312,-0.51563 -4.40625,0.0469 -7.45313,2.8125 -3.04687,2.71875 -3.04687,6.32812 0.0937,3.42188 2.53125,5.48438 2.48437,2.01562 7.96875,4.54687 3.75,1.78125 6.09375,3.14063 2.39062,1.35937 4.6875,3.51562 2.29687,2.15625 3.70312,5.4375 1.40625,3.28125 1.5,7.78125 0,4.125 -1.73437,7.875 -1.73438,3.70313 -4.82813,6.5625 -3.09375,2.85938 -7.125,4.5 -3.98437,1.59375 -8.34375,1.59375 z m 34.28125,-69.09374 h 31.96875 v 10.5 h -21.42187 v 18.74999 h 21.42187 v 10.5 h -21.42187 v 18.75 h 21.42187 v 10.5 h -31.96875 z",
    id: "path2978"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2893",
    transform: "matrix(0.34248285,0,0,0.34248285,56.071134,72.801078)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82bd3f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 117.45198,92.885809 c 0,0 8.75069,-7.225344 15.81547,-9.55351 0,0 14.69153,-5.218304 28.41969,-1.445069 0,0 10.83801,1.926758 20.63237,11.159142 l -6.18168,6.101401 c 0,0 3.61267,1.445067 3.4521,5.218307 0,0 -0.4014,5.61971 -5.61971,5.45915 0,0 -3.37182,0.48169 -4.97746,-3.13099 l -6.50281,6.50281 c 0,0 -10.83801,-10.35632 -25.04785,-0.24084 l -3.45211,-3.29155 c 0,0 3.29154,-4.09436 0.4014,-9.954916 0,0 -4.25492,-8.028159 -13.64787,-3.53239 z",
    id: "path2893"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fdebd3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 114.48339,160.97786 c 0,0 -28.264996,-30.46262 0.056,-64.964463 l 6.13145,6.124783 c 0,0 2.02291,-3.798697 6.26645,-2.968438 0,0 4.61255,0.738007 4.33579,5.904058 0,0 0.1845,2.76753 -3.13653,4.5203 l 6.45757,6.36531 c 0,0 -10.23986,11.16236 -0.0923,24.90775 l -3.41324,3.69004 c 0,0 -5.02749,-4.2896 -11.43911,0.64575 0,0 -6.3579,4.38162 -1.90091,12.45388 z",
    id: "path2894"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#82bd3f",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 117.49252,163.77401 6.13301,-6.13301 c 0,0 -3.74795,-1.36289 -3.18008,-5.50835 0,0 0.0568,-5.05405 6.07622,-5.22441 0,0 2.72578,0.0568 4.54297,3.23686 l 6.30336,-6.30337 24.2481,24.2481 c 0,0 2.10112,2.15791 2.38506,3.80474 l -0.0568,9.1995 h -29.30215 z",
    id: "path2895"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fdebd3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      strokeOpacity: 1
    },
    d: "m 185.48849,95.80159 c 0,0 28.265,30.46262 -0.056,64.96446 l -6.13145,-6.12478 c 0,0 -2.02291,3.7987 -6.26645,2.96844 0,0 -4.61255,-0.73801 -4.33579,-5.90406 0,0 -0.1845,-2.76753 3.13653,-4.5203 l -6.45757,-6.36531 c 0,0 10.23986,-11.16236 0.0923,-24.90775 l 3.41324,-3.69004 c 0,0 5.02749,4.2896 11.43911,-0.64575 0,0 6.3579,-4.38162 1.90091,-12.45388 z",
    id: "path2896"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdebd3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 134.49744,186.12701 h 30.81348 c 0,0 1.81256,0.22658 1.89752,2.35066 0,0 0.0353,2.2657 -2.03913,2.49227 l -3.00204,0.11328 c 0,0 -1.7276,0.82132 -1.52935,2.46396 0,0 -0.085,1.52933 1.75592,2.37897 h 2.18073 c 0,0 1.58599,0.085 1.8692,2.23738 0,0 0.45314,2.29402 -1.78424,3.00205 h -2.43562 c 0,0 -2.12409,0.67971 -1.4727,3.05869 0,0 0.28321,1.4727 1.84088,1.8692 h 2.12409 c 0,0 0.79299,4.36147 -3.14366,4.95621 0,0 -2.2657,-0.085 -3.3419,1.58599 l -5.66424,6.99534 h -5.21111 l -6.31563,-7.73169 c -0.61213,-0.74938 -2.48604,-0.63868 -3.33466,-0.9692 0,0 -1.94749,-0.47034 -2.25251,-2.1662 -0.0257,-0.14292 -0.0257,-0.30501 -0.0287,-0.44754 l -0.0483,-2.30786 h 15.63331 c 0,0 1.55767,-0.50979 1.75591,-2.46395 0,0 0.16993,-1.78424 -1.92584,-2.52059 h -15.4917 c 0,0 -1.89752,-0.3965 -1.81256,-2.43562 0,0 -0.19825,-2.01081 1.69927,-2.52059 h 15.8882 c 0,0 1.89753,-0.84964 1.61431,-2.86044 0,0 0.14161,-1.47271 -1.69927,-2.06745 l -16.56791,-0.14161 c 0,0 -1.84088,-0.56642 -1.67095,-2.32234 0,0 -0.085,-1.75592 1.69927,-2.54891 z",
    id: "path2897"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.997f015fa0bdb77b47d818cb5ea8ae7d.svg";
export { ForwardRef as ReactComponent };